import {AttributeFilterSection} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/filter_section.types';
import {FilterLabels} from '@aboutyou/legacy-tracking-sdk';
import {FilterDropdownGeneric} from '@aboutyou/ui-components';
import React, {FC} from 'react';
import {useAttributeFilterSection} from '../../shared/useAttributeFilterSection';

type Props = {
  activeFilters: Map<string, Array<string> | undefined>;
  data: AttributeFilterSection;
  setFilter: (filterData: {
    filterId: string;
    filterSection: string;
    filterSlug?: string;
  }) => void;
  resetFilter: (slug: string) => void;
  isSingleSelect?: boolean;
  onOpen: (filterSlug: string, label: FilterLabels) => void;
  onClose: (filterSlug: string, label: FilterLabels) => void;
  filterLabel: FilterLabels;
};

export const FilterSectionAttribute: FC<Props> = ({
  activeFilters,
  data,
  setFilter,
  resetFilter,
  isSingleSelect,
  onClose,
  onOpen,
  filterLabel,
}) => {
  const {
    activeSlugFilters,
    slug,
    normalizedValues,
    label,
    headline,
    description,
    handleAttributeClick,
  } = useAttributeFilterSection({
    data,
    activeFilters,
    setFilter,
    isSingleSelect,
  });

  return (
    <FilterDropdownGeneric
      activeItemIds={activeSlugFilters}
      dataTestId={`filterDropdownSection_${slug}`}
      items={normalizedValues}
      label={label}
      headline={headline}
      description={description}
      onAttributeClick={handleAttributeClick}
      onFilterReset={() => resetFilter(slug)}
      isSingleSelect={isSingleSelect}
      onClose={() => onClose(slug, filterLabel)}
      onOpen={() => onOpen(slug, filterLabel)}
      shouldDisplaySearchField={slug === 'productSeries'}
      padContent={false}
    />
  );
};
